<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";


const { t } = useI18n();
const isMobileDevice = ref(false);
const alertClosed = ref(false);

// 更全面的设备检测方法
const checkDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  
  // 移动设备检测
  const isMobile = /iphone|ipod|ipad|android|mobile|blackberry|webos|windows phone|iemobile|opera mini/i.test(userAgent);
  
  // 平板设备检测
  const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/i.test(userAgent);
  
  // 屏幕尺寸检测（可选）
  const isSmallScreen = window.innerWidth < 768;
  
  return isMobile || isTablet || isSmallScreen;
};

const closeAlert = () => {
  alertClosed.value = true;
  isMobileDevice.value = false;
  localStorage.setItem("device-alert-closed", "true");
};

onMounted(() => {
  // 检查是否已经关闭过提示
  const alreadyClosed = localStorage.getItem("device-alert-closed");

  if (!alreadyClosed) {
    isMobileDevice.value = checkDeviceType();
    
    // 添加窗口大小变化监听
    const handleResize = () => {
      if (!alertClosed.value) {
        isMobileDevice.value = checkDeviceType();
      }
    };
    
    window.addEventListener('resize', handleResize);
    
    // 组件卸载时移除监听
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }
});
</script>

<template>
  <div v-if="isMobileDevice && !alertClosed" class="device-alert">
    <div class="device-alert-content">
      <i class="device-alert-icon"></i>
      <div class="device-alert-message">
        <h3>{{ t("deviceAlert.title") }}</h3>
        <p>{{ t("deviceAlert.message") }}</p>
        <el-button type="primary mt-[1rem]" @click="closeAlert">
          {{ t("deviceAlert.close") }}
        </el-button>
      </div>
      <button class="device-alert-close" @click="closeAlert" aria-label="Close">
        <span>×</span>
      </button>
    </div>
  </div>
</template>

<style scoped>
.device-alert {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.device-alert-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  max-width: 400px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  padding: 24px;
  position: relative;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.device-alert-icon {
  display: inline-block;
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23f39c12'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
}

.device-alert-message {
  text-align: center;
  width: 100%;
}

.device-alert-message h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #333;
  font-weight: 600;
}

.device-alert-message p {
  margin: 12px 0 20px;
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
}

.device-alert-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: #999;
  padding: 4px;
  transition: color 0.2s;
}

.device-alert-close:hover {
  color: #333;
}

@media (max-width: 480px) {
  .device-alert-content {
    padding: 20px 16px;
    max-width: 90%;
  }
  
  .device-alert-message h3 {
    font-size: 1.1rem;
  }
  
  .device-alert-message p {
    font-size: 0.9rem;
  }
}
</style>